// Auto generated by typegen from Prisma Schema

export enum ClaimState {
	NEW = "NEW",
	OPEN = "OPEN",
	DISMISSED = "DISMISSED",
	DENIED = "DENIED",
	APPROVED = "APPROVED",
	RESOLVED = "RESOLVED",
	ARCHIVED = "ARCHIVED",
	COMMUNICATING = "COMMUNICATING",
	WAITING_FOR_CUSTOMER = "WAITING_FOR_CUSTOMER",
	WAITING_FOR_BRAND = "WAITING_FOR_BRAND",
	WAITING_FOR_OP = "WAITING_FOR_OP",
	RESOLVED_BY_BRAND = "RESOLVED_BY_BRAND",
	TEMPORARILY_DISMISSED = "TEMPORARILY_DISMISSED",
	CLOSED = "CLOSED",
	DRAFT = "DRAFT",
}

export enum ClaimFiledFrom {
	EXTERNAL = "EXTERNAL",
	INTERNAL = "INTERNAL",
}

export enum ClaimType {
	STOLEN = "STOLEN",
	DAMAGED = "DAMAGED",
	DEFECTIVE_ITEM = "DEFECTIVE_ITEM",
	ORDER_DELIVERED_NOT_RECEIVED = "ORDER_DELIVERED_NOT_RECEIVED",
	WRONG_ITEM = "WRONG_ITEM",
	MISSING_ITEM = "MISSING_ITEM",
	RETURNED_TO_SENDER = "RETURNED_TO_SENDER",
	TRACKING_NOT_MOVING = "TRACKING_NOT_MOVING",
	MULTIPLE = "MULTIPLE",
	WRONG_ADDRESS = "WRONG_ADDRESS",
}

export enum ClaimCategory {
	SHIPPING = "SHIPPING",
	WARRANTY = "WARRANTY",
}

export enum SalesChannel {
	ONLINE = "ONLINE",
	IN_STORE = "IN_STORE",
}

export enum ResolutionType {
	RESHIP = "RESHIP",
	DRAFT_ORDER = "DRAFT_ORDER",
	REPLACEMENT = "REPLACEMENT",
	REFUND = "REFUND",
	FLAT_RATE = "FLAT_RATE",
	FLAT_RATE_STORE_CREDIT = "FLAT_RATE_STORE_CREDIT",
	CUSTOM = "CUSTOM",
	EXPIRED30 = "EXPIRED30",
	EXCHANGE = "EXCHANGE",
	CREDIT = "CREDIT",
	STORE_CREDIT = "STORE_CREDIT",
	RETURN = "RETURN",
	OTHER = "OTHER",
	NO_RESPONSE = "NO_RESPONSE",
	PACKAGE_ARRIVED = "PACKAGE_ARRIVED",
	CUSTOMER_RESPONDED = "CUSTOMER_RESPONDED",
	FOLLOW_UP = "FOLLOW_UP",
	INSUFFICIENT_SHIPPER = "INSUFFICIENT_SHIPPER",
	RETURN_TO_SENDER = "RETURN_TO_SENDER",
	NOT_COVERED = "NOT_COVERED",
	ADRESS_TYPO = "ADRESS_TYPO",
	PHOTO_VERIFIED = "PHOTO_VERIFIED",
	THRESHOLD_REACHED = "THRESHOLD_REACHED",
	ADDRESS_TYPO = "ADDRESS_TYPO",
	ALREADY_REFUNDED = "ALREADY_REFUNDED",
	ALREADY_REPLACED = "ALREADY_REPLACED",
	POTENTIAL_FRAUD = "POTENTIAL_FRAUD",
	NOT_MERCHANT_PRODUCT = "NOT_MERCHANT_PRODUCT",
}

export enum ResolutionSubject {
	ITEM = "ITEM",
	SHIPPING = "SHIPPING",
	TAXES = "TAXES",
	ACTION = "ACTION",
}

export enum OriginalSelectionState {
	CORRECT = "CORRECT",
	WRONG = "WRONG",
	NOT_FOUND = "NOT_FOUND",
}

export enum ValidationEvidence {
	RECEIPT = "RECEIPT",
	IMAGE = "IMAGE",
	DESCRIPTION = "DESCRIPTION",
}

export enum ProductSelectionSource {
	SEARCH = "SEARCH",
	AI_FINDER = "AI_FINDER",
	CLOSE_MATCH = "CLOSE_MATCH",
	NOT_FOUND = "NOT_FOUND",
}

export enum SubstituteBasis {
	MODEL = "MODEL",
	COLOR = "COLOR",
	SIZE = "SIZE",
	PRICING = "PRICING",
}

export enum ValidationOutcome {
	VALIDATED = "VALIDATED",
	REJECTED = "REJECTED",
}

export enum ValidationType {
	SHIPPING = "SHIPPING",
	WARRANTY = "WARRANTY",
}

export enum ClaimSessionStatus {
	PROCESS = "PROCESS",
	ISSUES = "ISSUES",
	ISSUES_ITEMS = "ISSUES_ITEMS",
	ISSUES_SHIPMENT = "ISSUES_SHIPMENT",
	ISSUES_SHIPMENT_DETAILS = "ISSUES_SHIPMENT_DETAILS",
	MULTIPLE_SHIPMENTS = "MULTIPLE_SHIPMENTS",
	RESOLUTION = "RESOLUTION",
	RESOLUTION_REVIEW = "RESOLUTION_REVIEW",
}

export enum StoreCreditType {
	GIFT_CARD = "GIFT_CARD",
	DISCOUNT_CODE = "DISCOUNT_CODE",
	ACCOUNT_CREDIT = "ACCOUNT_CREDIT",
}

export enum StoreCreditProvider {
	SHOPIFY = "SHOPIFY",
	RISE_AI = "RISE_AI",
}

export enum ActivityType {
	MESSAGE = "MESSAGE",
	EVENT = "EVENT",
}

export enum ActivitySourceType {
	SYSTEM = "SYSTEM",
	USER = "USER",
	OTHER = "OTHER",
}

export enum HybridOperator {
	AND = "AND",
	OR = "OR",
}

export enum Origination {
	ORDER = "ORDER",
	CLAIM = "CLAIM",
}

export enum PolicyType {
	SHIPPING = "SHIPPING",
	MANUFACTURER_WARRANTY = "MANUFACTURER_WARRANTY",
	EXTENDED_WARRANTY = "EXTENDED_WARRANTY",
}

export enum ResolutionValueBasis {
	PRICE_PAID = "PRICE_PAID",
	RETAIL_PRICE = "RETAIL_PRICE",
}

export enum PremiumSource {
	OP_LINE = "OP_LINE",
	SHIPPING_TIER = "SHIPPING_TIER",
}

export enum ClaimPauseSource {
	TAKEOVER = "TAKEOVER",
	STOP = "STOP",
}

export enum ClaimPauseEvent {
	PAUSED = "PAUSED",
	EXTENDED = "EXTENDED",
	NUDGED = "NUDGED",
	RESUMED = "RESUMED",
	HANDED_BACK = "HANDED_BACK",
	REAPED = "REAPED",
	RESET = "RESET",
	ABORTED = "ABORTED",
}

export enum ClaimPauseReason {
	WAITING_ON_BRAND = "WAITING_ON_BRAND",
	AI_ERROR = "AI_ERROR",
	CUSTOMER_ESCALATION = "CUSTOMER_ESCALATION",
	HANDLING_MANUALLY = "HANDLING_MANUALLY",
	POLICY_GAP = "POLICY_GAP",
	QA_TESTING = "QA_TESTING",
	OTHER = "OTHER",
}

export enum PricingModel {
	COST_PER_ORDER = "COST_PER_ORDER",
	COST_PER_ORDER_ITEM = "COST_PER_ORDER_ITEM",
	COST_PER_RESOLUTION = "COST_PER_RESOLUTION",
}

export enum ResetType {
	CLAIM = "CLAIM",
	CLAIM_TYPE = "CLAIM_TYPE",
}

export enum SenderType {
	customer = "customer",
	brand = "brand",
	admin = "admin",
	automatic = "automatic",
	system = "system",
}

export enum ResolutionStatus {
	PENDING = "PENDING",
	SUCCESS = "SUCCESS",
	FAILED = "FAILED",
	MISMATCH = "MISMATCH",
	INDETERMINATE = "INDETERMINATE",
}

export enum MessageAmountStatus {
	VERIFIED = "VERIFIED",
	MISMATCH = "MISMATCH",
	NO_MATCH = "NO_MATCH",
}

export enum ResolutionQuoteLayerType {
	ITEM = "ITEM",
	SHIPPING = "SHIPPING",
	ADJUSTMENT = "ADJUSTMENT",
}

export enum ResolutionQuoteAdjustmentKind {
	COURTESY = "COURTESY",
	SOP_APPEASEMENT = "SOP_APPEASEMENT",
	PRICE_ADJUSTMENT = "PRICE_ADJUSTMENT",
	STORE_CREDIT_BONUS = "STORE_CREDIT_BONUS",
}

export enum CalcMethod {
	percentage = "percentage",
	fixed = "fixed",
}

export enum DocumentType {
	SIGNATURE = "SIGNATURE",
	ACKNOWLEDGEMENT = "ACKNOWLEDGEMENT",
	RECEIPT = "RECEIPT",
}

export enum StoreCreditRedeemedStatus {
	YES = "YES",
	NO = "NO",
	PARTIALLY = "PARTIALLY",
}

export enum ClaimResolutionLineType {
	ITEM = "ITEM",
	SHIPPING = "SHIPPING",
	CREDIT_BONUS = "CREDIT_BONUS",
	ORDER = "ORDER",
}

export enum CalculationType {
	FLAT = "FLAT",
	FULL = "FULL",
	PERCENTAGE = "PERCENTAGE",
}

export enum AutomationAction {
	RESOLVE = "RESOLVE",
	SEND_MESSAGE = "SEND_MESSAGE",
	WAIT = "WAIT",
	ESCALATE = "ESCALATE",
	UPDATE_CLAIM_TYPE = "UPDATE_CLAIM_TYPE",
	UPDATE_SHIPPING_ADDRESS = "UPDATE_SHIPPING_ADDRESS",
	VALIDATE_OFFLINE = "VALIDATE_OFFLINE",
}

export enum EscalationKind {
	CAPABILITY = "CAPABILITY",
	JUDGEMENT = "JUDGEMENT",
}

export enum EscalationTrigger {
	VALUE_GUARDRAIL = "VALUE_GUARDRAIL",
	SOP_REQUIRES_APPROVAL = "SOP_REQUIRES_APPROVAL",
	BRAND_OWNED = "BRAND_OWNED",
	FRAUD_RISK = "FRAUD_RISK",
	CUSTOMER_REQUESTED_HUMAN = "CUSTOMER_REQUESTED_HUMAN",
	LEGAL_OR_SAFETY = "LEGAL_OR_SAFETY",
	EVIDENCE_REVIEW = "EVIDENCE_REVIEW",
	CUSTOMER_UNRESPONSIVE = "CUSTOMER_UNRESPONSIVE",
	NO_ENABLED_RESOLUTION = "NO_ENABLED_RESOLUTION",
	TOOL_OR_PLATFORM_LIMIT = "TOOL_OR_PLATFORM_LIMIT",
	PRICING_FAILURE = "PRICING_FAILURE",
	OTHER = "OTHER",
}

export enum EscalationHandledReason {
	REPLIED_TO_CUSTOMER = "REPLIED_TO_CUSTOMER",
}

export enum AutomationEventSource {
	CLAIM_CREATED = "CLAIM_CREATED",
	STATE_CHANGE = "STATE_CHANGE",
	RESOLUTION_CREATED = "RESOLUTION_CREATED",
	NEW_MESSAGE = "NEW_MESSAGE",
	MANUAL = "MANUAL",
	FULFILLMENT_UPDATED = "FULFILLMENT_UPDATED",
	FRAUD_UPDATED = "FRAUD_UPDATED",
	EXTERNAL_REQUEST = "EXTERNAL_REQUEST",
	SLACK_ESCALATION_REPLY = "SLACK_ESCALATION_REPLY",
	NEW_NOTE = "NEW_NOTE",
	COURSE_CORRECTION = "COURSE_CORRECTION",
	TRACKING_UPDATE = "TRACKING_UPDATE",
	REAPED_RETRY = "REAPED_RETRY",
	PAUSE_TIMEOUT = "PAUSE_TIMEOUT",
	ESCALATION_AUTO_APPROVE = "ESCALATION_AUTO_APPROVE",
	POST_RESOLUTION_QUESTION = "POST_RESOLUTION_QUESTION",
}

export enum AIDecision {
	APPROVE = "APPROVE",
	DENY = "DENY",
	CLOSE = "CLOSE",
}

export enum AgentDecision {
	ACCEPTED = "ACCEPTED",
	REJECTED = "REJECTED",
	AUTO_EXECUTED = "AUTO_EXECUTED",
}

export enum ClaimAutomationStatus {
	PENDING = "PENDING",
	PROCESSING = "PROCESSING",
	COMPLETED = "COMPLETED",
	SUPERSEDED = "SUPERSEDED",
	STOPPED = "STOPPED",
	FAILED = "FAILED",
}

export enum AiVendor {
	ANTHROPIC = "ANTHROPIC",
	OPENAI = "OPENAI",
	GEMINI = "GEMINI",
	KIMI = "KIMI",
	TYPESAFE = "TYPESAFE",
	GOOGLE_CLOUD = "GOOGLE_CLOUD",
}

export enum AiRequestRoute {
	OPENROUTER = "OPENROUTER",
	DIRECT = "DIRECT",
}

export enum AiRequestStatus {
	SUCCEEDED = "SUCCEEDED",
	FAILED = "FAILED",
	ABORTED = "ABORTED",
}

export enum AiAuditSeverity {
	HIGH = "HIGH",
	LOW = "LOW",
}
export enum AiFeature {
	CLAIM_AUTOMATION = "CLAIM_AUTOMATION",
	CLAIM_MESSAGE_TRIAGE = "CLAIM_MESSAGE_TRIAGE",
	REACTION_LANE = "REACTION_LANE",
	PRODUCT_FINDER = "PRODUCT_FINDER",
	PRODUCT_INDEX = "PRODUCT_INDEX",
	RECEIPT_READER = "RECEIPT_READER",
	MEDIA_ANALYSIS = "MEDIA_ANALYSIS",
	METABASE_REPORT = "METABASE_REPORT",
	SLACK_BOT = "SLACK_BOT",
	THEME_AUTOMATION = "THEME_AUTOMATION",
	SOP_GENERATION = "SOP_GENERATION",
	AUTOMATION_TRAINING = "AUTOMATION_TRAINING",
	NOTE_ACTION_GATE = "NOTE_ACTION_GATE",
	POD_SCAN = "POD_SCAN",
	BRAND_INQUIRY = "BRAND_INQUIRY",
	MCP_DECIDE = "MCP_DECIDE",
	UNATTRIBUTED = "UNATTRIBUTED",
	FRAUD_SIGNALS = "FRAUD_SIGNALS",
	AI_DECISION_AUDIT = "AI_DECISION_AUDIT",
}

export enum ClaimAutomationToolRunKind {
	PREFETCH = "PREFETCH",
	AGENT = "AGENT",
}

export enum ClaimAutomationToolRunSource {
	LIVE = "LIVE",
	SNAPSHOT = "SNAPSHOT",
	CAPTURED_WRITE = "CAPTURED_WRITE",
	REJECTED_WRITE = "REJECTED_WRITE",
	BLOCKED = "BLOCKED",
}

export enum ClaimAutomationToolRunErrorCode {
	TOOL_ERROR = "TOOL_ERROR",
	TOOL_CALL_THREW = "TOOL_CALL_THREW",
	TOOL_NOT_AVAILABLE = "TOOL_NOT_AVAILABLE",
	TOOL_NOT_OFFERED_CLOSING_PHASE = "TOOL_NOT_OFFERED_CLOSING_PHASE",
	INVALID_TOOL_INPUT = "INVALID_TOOL_INPUT",
	WRITE_VALIDATION_EXHAUSTED = "WRITE_VALIDATION_EXHAUSTED",
	ONE_WRITE_PER_RUN = "ONE_WRITE_PER_RUN",
}

export enum FeedbackType {
	MESSAGE = "MESSAGE",
	RESOLVE = "RESOLVE",
	GUIDANCE = "GUIDANCE",
	TAKEOVER = "TAKEOVER",
}

export enum FeedbackReviewStatus {
	PENDING = "PENDING",
	AUDITED = "AUDITED",
	APPLIED = "APPLIED",
	REJECTED = "REJECTED",
}

export enum TrainingIssueStatus {
	OPEN = "OPEN",
	INVESTIGATING = "INVESTIGATING",
	FIX_IN_PROGRESS = "FIX_IN_PROGRESS",
	FIX_MERGED = "FIX_MERGED",
	RESOLVED = "RESOLVED",
	CLOSED = "CLOSED",
}

export enum TrainingIssueCloseReason {
	AGENT_WRONG = "AGENT_WRONG",
	SOP_CHANGED = "SOP_CHANGED",
	CODE_FIX = "CODE_FIX",
	WONT_FIX = "WONT_FIX",
}

export interface Policy {
	id: string;
	orderId: string;
	storeId: string;
	insuredAmount: number;
	premiumPaid: number;
	premiumDiscountedAmount: number;
	premiumCurrency: string;
	fundedBy: string;
	customerAmount: number;
	brandAmount: number;
	hybridOperator: HybridOperator | null;
	policyType: PolicyType;
	pricingModel: PricingModel | null;
	premiumSource: PremiumSource;
	refundBasis: ResolutionValueBasis | null;
	storeCreditBasis: ResolutionValueBasis | null;
	createdAt: string | null;
	updatedAt: string | null;
	removedAt: string | null;
	deletedAt: string | null;
	warranty: Warranty[];
	claim: Claim[];
}

export interface Warranty {
	id: string;
	policyId: string;
	orderItemId: string;
	warrantyId: string;
	validUntil: string | null;
	validity: string;
	policy: Policy;
}

export interface Activity {
	id: string;
	claimId: string;
	source: string;
	sourceType: ActivitySourceType;
	activityType: ActivityType;
	description: string;
	imageUrl: string | null;
	createdAt: string;
	claim: Claim;
}

export interface Claim {
	id: string;
	storeId: string;
	orderId: string;
	sourceOrderId: string;
	sourceOrderNumber: string;
	customerId: string | null;
	authorName: string;
	authorEmail: string;
	claimDescription: string;
	claimState: ClaimState;
	isOta: boolean;
	otaDescription: string | null;
	claimSource: string | null;
	claimType: ClaimType | null;
	claimCategory: ClaimCategory;
	salesChannel: SalesChannel;
	claimFiledFrom: ClaimFiledFrom;
	suppressCommunications: boolean;
	closedAt: string | null;
	assignedToUserId: string | null;
	assignedAt: string | null;
	lastTouchedByUserId: string | null;
	lastTouchedAt: string | null;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claimItems: ClaimItem[];
	claimMessages: ClaimMessage[];
	claimResolutions: ClaimResolution[];
	claimCredits: ClaimCredit[];
	review: Review | null;
	claimStoreCredits: ClaimStoreCredit[];
	claimReset: ClaimReset[];
	claimAutomations: ClaimAutomation[];
	claimResolutionRecords: ClaimResolutionRecord[];
	resolutionOutcomes: ClaimResolutionOutcome[];
	resolutionQuotes: ResolutionQuote[];
	activities: Activity[];
	aiRequests: AiRequest[];
	policy: Policy | null;
	policyId: string | null;
	claimDocuments: ClaimDocument[];
	offlineMetadata: OfflineMetadata | null;
	automationPause: ClaimAutomationPause | null;
	automationPauseEvents: ClaimAutomationPauseEvent[];
}

export interface ClaimAutomationPause {
	id: string;
	claimId: string;
	claim: Claim;
	pausedAt: string;
	pausedBy: string;
	reason: string | null;
	reasonCode: ClaimPauseReason | null;
	dueAt: string;
	nudgedAt: string | null;
	extendedAt: string | null;
	extendCount: number;
	source: ClaimPauseSource;
}

export interface ClaimAutomationPauseEvent {
	id: string;
	claimId: string;
	claim: Claim;
	storeId: string;
	pauseId: string;
	event: ClaimPauseEvent;
	source: ClaimPauseSource;
	actorId: string;
	pausedBy: string;
	reasonCode: ClaimPauseReason | null;
	reason: string | null;
	claimState: string | null;
	automationId: string | null;
	scheduledExecutionAt: string | null;
	pausedAt: string;
	createdAt: string;
}

export interface OfflineMetadata {
	id: string;
	claimId: string;
	receiptRequired: boolean;
	dateOfPurchase: string;
	isValidated: boolean;
	externalSalesChannel: string | null;
	externalOrderNumber: string | null;
	originalShipping: number | null;
	originalTax: number | null;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claim: Claim;
}

export interface ClaimItemImage {
	id: string;
	url: string;
	claimItemId: string;
	filename: string | null;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: ClaimItem;
}

export interface ClaimItem {
	id: string;
	name: string;
	claimId: string;
	orderId: string;
	sourceItemId: string | null;
	sourceOrderId: string;
	sourceProductId: string | null;
	sourceVariantId: string | null;
	sku: string | null;
	resolutionRequested: ResolutionType | null;
	resolutionFinal: ResolutionType | null;
	reshipIfRestocked: boolean;
	isAdditionalItem: boolean;
	imageUrl: string | null;
	quantity: number;
	resolutionQuantity: number | null;
	resolutionPercentage: number | null;
	resolutionFlatAmount: number | null;
	resolutionId: string | null;
	claimType: ClaimType;
	claimSubtypeId: string | null;
	details: string;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: Claim;
	resolution: ClaimResolution | null;
	images: ClaimItemImage[];
	claimSubtype: ClaimSubtype | null;
	claimResolutionLines: ClaimResolutionLine[];
	claimItemMetadata: ClaimItemMetadata | null;
	validation: ClaimItemValidation | null;
}

export interface ClaimItemValidation {
	id: string;
	claimItemId: string;
	validationType: ValidationType;
	validationOutcome: ValidationOutcome;
	originalSelectionState: OriginalSelectionState | null;
	evidence: ValidationEvidence[];
	isSubstitute: boolean;
	substituteBasis: SubstituteBasis[];
	productChanged: boolean;
	originalProductName: string;
	originalSku: string | null;
	originalSourceProductId: string | null;
	originalSourceVariantId: string | null;
	originalProductImageUrl: string | null;
	originalQuantity: number;
	originalDescription: string | null;
	dateOfPurchase: string | null;
	validatedBy: string;
	validatedAt: string;
	claimItem: ClaimItem;
}

export interface ClaimItemMetadata {
	id: string;
	claimItemId: string;
	productValue: number | null;
	productDescription: string | null;
	warrantyPeriod: string | null;
	warrantyFee: number | null;
	selectionSource: ProductSelectionSource | null;
	isSubstitute: boolean;
	substituteBasis: SubstituteBasis[];
	matchScore: number | null;
	originalProductName: string | null;
	replacementSourceProductId: string | null;
	replacementSourceVariantId: string | null;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claimItem: ClaimItem;
}

export interface ClaimSession {
	id: string;
	orderId: string;
	email: string;
	status: ClaimSessionStatus;
	metadata: object | null;
	createdAt: string;
	updatedAt: string;
}

export interface ClaimReset {
	id: string;
	claimId: string;
	userId: string | null;
	resetType: ResetType;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claim: Claim;
}

export interface ClaimMessage {
	id: string;
	messageContent: string;
	senderName: string;
	senderType: SenderType;
	senderId: string | null;
	readAt: string | null;
	claimId: string;
	automationId: string | null;
	htmlBody: string | null;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: Claim;
	automation: ClaimAutomation | null;
	medias: ClaimMessageMedia[];
}

export interface ClaimResolution {
	id: string;
	claimId: string;
	userId: string | null;
	resolutionType: ResolutionType;
	resolutionDetails: string;
	paidValue: number;
	paidCurrency: string;
	paidOriginalValue: number;
	includeShipping: boolean;
	shippingAmount: number;
	creditStore: boolean;
	overrideShipping: boolean;
	automationId: string | null;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: Claim;
	credits: ClaimCredit[];
	claimItems: ClaimItem[];
	automation: ClaimAutomation | null;
}

export interface ClaimResolutionRecord {
	id: string;
	claimId: string;
	userId: string;
	resolutionType: ResolutionType;
	currency: string;
	totalAmount: number;
	creditedAmount: number;
	notCreditedAmount: number;
	exchangeRate: number;
	automationId: string | null;
	details: string | null;
	amountBreakdown: object | null;
	reshipExternalOrderId: string | null;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claim: Claim;
	automation: ClaimAutomation | null;
	lines: ClaimResolutionLine[];
	outcomes: ClaimResolutionOutcome[];
}

export interface ClaimResolutionLine {
	id: string;
	lineType: ClaimResolutionLineType;
	calculationType: CalculationType;
	resolutionType: ResolutionType;
	claimType: ClaimType;
	lineItemId: string | null;
	quantity: number;
	percentage: number;
	resolvedAmount: number;
	creditStore: boolean;
	coveredAmount: number;
	coverageRuleId: string | null;
	resolutionRecordId: string;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claimItem: ClaimItem | null;
	resolutionRecord: ClaimResolutionRecord;
}

export interface ClaimResolutionOutcome {
	id: string;
	claimId: string;
	resolutionRecordId: string;
	storeId: string;
	resolutionType: ResolutionType;
	promisedAmount: number | null;
	currency: string | null;
	deliveredAmount: number | null;
	status: ResolutionStatus;
	messageAmountStatus: MessageAmountStatus | null;
	cause: string | null;
	reportedAt: string | null;
	externalId: string | null;
	errorMessage: string | null;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claim: Claim;
	resolutionRecord: ClaimResolutionRecord;
}

export interface ResolutionQuote {
	id: string;
	claimId: string;
	storeId: string;
	automationId: string;
	intent: object;
	refundTotal: number;
	storeCreditTotal: number;
	grandTotal: number;
	currency: string;
	flags: string[];
	executedRecordId: string | null;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claim: Claim;
	automation: ClaimAutomation;
	layers: ResolutionQuoteLayer[];
}

export interface ResolutionQuoteLayer {
	id: string;
	quoteId: string;
	position: number;
	type: ResolutionQuoteLayerType;
	instrument: ResolutionType;
	amount: number;
	quantity: number;
	calculationType: CalculationType;
	percentage: number;
	claimItemId: string | null;
	formula: string;
	adjustmentKind: ResolutionQuoteAdjustmentKind | null;
	reason: string | null;
	sopRef: string | null;
	createdAt: string;
	quote: ResolutionQuote;
}

export interface ClaimCredit {
	id: string;
	claimId: string;
	claimResolutionId: string;
	creditAmount: number;
	creditTarget: string;
	creditCurrency: string;
	creditReason: string;
	creditIssuedBy: string;
	paymentGateway: string;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: Claim;
	resolution: ClaimResolution;
}

export interface ClaimStoreCredit {
	id: string;
	sourceId: string | null;
	claimId: string | null;
	storeId: string | null;
	origination: Origination;
	orderId: string | null;
	type: StoreCreditType;
	provider: StoreCreditProvider;
	code: string;
	emailStatus: string;
	emailTime: string | null;
	creditCurrency: string;
	exchangeRate: number;
	creditValue: number;
	bonusValue: number | null;
	totalValue: number;
	bonus: number | null;
	bonusType: CalcMethod | null;
	remainingValue: number | null;
	redeemed: StoreCreditRedeemedStatus | null;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: Claim | null;
	claimStoreCreditUsage: ClaimStoreCreditUsage[];
}

export interface ClaimMessageMedia {
	id: string;
	claimMessageId: string;
	fileKey: string;
	caption: string;
	filename: string;
	downloadLink: string | null;
	url: string;
	fileType: string | null;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claimMessage: ClaimMessage;
}

export interface ClaimDocument {
	id: string;
	url: string;
	claimId: string;
	documentType: DocumentType;
	createdAt: string | null;
	updatedAt: string | null;
	deletedAt: string | null;
	claim: Claim;
}

export interface ClaimStoreCreditUsage {
	id: string;
	claimStoreCreditId: string;
	orderId: string;
	usageAmount: number;
	usedAt: string;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claimStoreCredit: ClaimStoreCredit;
	warrantyMetadataId: string | null;
}

export interface Review {
	id: string;
	claimId: string;
	rating: number;
	comments: string | null;
	checkedAt: string | null;
	checkedById: string | null;
	noteCount: number;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claim: Claim;
}

export interface ClaimSubtype {
	id: string;
	name: string;
	category: ClaimCategory;
	parentType: ClaimType;
	storeId: string;
	createdAt: string;
	updatedAt: string;
	voidedAt: string | null;
	claimItems: ClaimItem[];
}

export interface ClaimAutomation {
	id: string;
	claimId: string;
	storeId: string | null;
	status: ClaimAutomationStatus;
	action: AutomationAction | null;
	actionObject: object | null;
	aiDecision: AIDecision | null;
	agentDecision: AgentDecision | null;
	suggestedResolution: ResolutionType | null;
	suggestedAmount: number | null;
	reason: string | null;
	confidence: number | null;
	pendingToolCall: object | null;
	commitHash: string | null;
	complianceReport: string | null;
	confidenceScorecard: object | null;
	isActive: boolean;
	escalationNudgedAt: string | null;
	autoApproveFailedAt: string | null;
	scheduledExecutionAt: string | null;
	executionJobId: string | null;
	executedAt: string | null;
	executionStoppedAt: string | null;
	finishedAt: string | null;
	handledAt: string | null;
	escalationHandledReason: EscalationHandledReason | null;
	handledByUserId: string | null;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	fraudReportId: string | null;
	eventSource: AutomationEventSource | null;
	escalationKind: EscalationKind | null;
	escalationTrigger: EscalationTrigger | null;
	recommendationApprovalId: string | null;
	decidedByUserId: string | null;
	approvedEscalationId: string | null;
	feedback: ClaimAutomationFeedback[];
	resolutions: ClaimResolution[];
	resolutionRecords: ClaimResolutionRecord[];
	message: ClaimMessage | null;
	resolutionQuote: ResolutionQuote | null;
	toolRuns: ClaimAutomationToolRun[];
	flag: ClaimAutomationFlag | null;
	aiRequests: AiRequest[];
	approvedEscalation: ClaimAutomation | null;
	approvals: ClaimAutomation[];
	claim: Claim;
}

export interface ClaimAutomationToolRun {
	id: string;
	automationId: string;
	claimId: string;
	storeId: string;
	position: number;
	kind: ClaimAutomationToolRunKind;
	source: ClaimAutomationToolRunSource;
	iteration: number | null;
	toolUseId: string | null;
	toolName: string;
	input: object;
	inputBytes: number;
	result: string | null;
	resultBytes: number | null;
	resultTruncated: boolean;
	isError: boolean | null;
	errorCode: ClaimAutomationToolRunErrorCode | null;
	errorMessage: string | null;
	inPrompt: boolean | null;
	assistantText: string | null;
	startedAt: string;
	endedAt: string | null;
	createdAt: string;
	automation: ClaimAutomation;
}
export interface ClaimAutomationFlag {
	id: string;
	claimAutomationId: string;
	storeId: string;
	severity: AiAuditSeverity;
	flaggedRules: string[];
	ruleScores: object;
	why: string;
	aiModelId: string | null;
	createdAt: string;
	updatedAt: string;
	automation: ClaimAutomation;
	aiModel: AiModel | null;
}

export interface ClaimAutomationFeedback {
	id: string;
	claimAutomationId: string;
	feedbackType: FeedbackType;
	userId: string;
	message: string | null;
	reviewStatus: FeedbackReviewStatus;
	storeSpecific: boolean;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	claimAutomation: ClaimAutomation;
}

export interface AiRequest {
	id: string;
	storeId: string | null;
	claimId: string | null;
	vendor: AiVendor;
	feature: AiFeature;
	providerRequestId: string | null;
	status: AiRequestStatus;
	errorMessage: string | null;
	input: object | null;
	output: object | null;
	inputTokens: number;
	outputTokens: number;
	cacheCreationInputTokens: number;
	cacheReadInputTokens: number;
	cost: number | null;
	latencyMs: number;
	runId: string | null;
	claimAutomationId: string | null;
	aiModelId: string | null;
	route: AiRequestRoute | null;
	iteration: number | null;
	metadata: object | null;
	createdAt: string;
	claim: Claim | null;
	claimAutomation: ClaimAutomation | null;
	aiModel: AiModel | null;
}

export interface AiModel {
	id: string;
	company: string;
	model: string;
	provider: string | null;
	createdAt: string;
	aiRequests: AiRequest[];
	features: AiFeatureModel[];
	fallbacks: AiFeatureFallbackModel[];
	flags: ClaimAutomationFlag[];
}

export interface AiFeatureModel {
	feature: AiFeature;
	aiModelId: string;
	aiModel: AiModel;
	fallbacks: AiFeatureFallbackModel[];
	updatedAt: string;
}

export interface AiFeatureFallbackModel {
	feature: AiFeature;
	featureModel: AiFeatureModel;
	position: number;
	aiModelId: string;
	aiModel: AiModel;
	updatedAt: string;
}

export interface TrainingIssue {
	id: string;
	storeId: string;
	fingerprint: string;
	status: TrainingIssueStatus;
	closeReason: TrainingIssueCloseReason | null;
	prUrl: string | null;
	note: string | null;
	mergedAt: string | null;
	resolvedAt: string | null;
	updatedByUserId: string | null;
	createdAt: string;
	updatedAt: string;
}
